import React from 'react'
import { ReactComponent as ArrowLogoRightSvg} from '../../assets/svgs/arrows/Arrow_Logo_Right.svg';

const ArrowLogoRightIcon = () => (
    <div>
        <ArrowLogoRightSvg/>
    </div>
)

export default ArrowLogoRightIcon